import { render } from "./UpdatePasswordView.vue?vue&type=template&id=556c091f&scoped=true"
import script from "./UpdatePasswordView.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordView.vue?vue&type=script&lang=js"

import "./UpdatePasswordView.vue?vue&type=style&index=0&id=556c091f&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556c091f"]])

export default __exports__